/**
 * Count work days (Mon–Fri) between two dates.
 * Positive means `from` is before `to`.
 */
export function workDaysBetween(from: Date, to: Date): number {
  let count = 0;
  const sign = to >= from ? 1 : -1;
  const start = sign === 1 ? new Date(from) : new Date(to);
  const end = sign === 1 ? new Date(to) : new Date(from);
  const cursor = new Date(start);
  while (cursor < end) {
    cursor.setDate(cursor.getDate() + 1);
    const day = cursor.getDay();
    if (day !== 0 && day !== 6) count++;
  }
  return count * sign;
}

/**
 * Add N work days to a date (skipping weekends).
 */
export function addWorkDays(from: Date, days: number): Date {
  const result = new Date(from);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) added++;
  }
  return result;
}

/**
 * Subtract N work days from a date (going backwards, skipping weekends).
 */
export function subtractWorkDays(from: Date, days: number): Date {
  const result = new Date(from);
  let subtracted = 0;
  while (subtracted < days) {
    result.setDate(result.getDate() - 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) subtracted++;
  }
  return result;
}
